import React, { FC } from 'react';
import useTranslations from '@hooks/useTranslations';
import { CheckoutTitleProps } from '.';
import { IS_B2B } from '../../constants/main';
import { MySavedDealJourneyType } from '../../redux/user/user.duck.interface';

enum STATUSES {
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    PENDING = 'PENDING',
}

const CheckoutTitleTemplate: FC<CheckoutTitleProps> = ({ className, status, journeyType, isAssistedFinance = false, isRentJourney = false }) => {
    const { t } = useTranslations();

    return (
        <div className={className} data-testid="TESTING_CHECKOUT_TITLE">
            {!isRentJourney &&
                !status &&
                t(
                    `checkout.preOrder.title.${
                        journeyType === MySavedDealJourneyType.BUY_ONLINE_CASH ? 'cash' : 'finance'
                    }${isAssistedFinance ? '.assisted' : ''}`
                )}
            {status === STATUSES.APPROVED && t(`checkout.orderReview.title.finance${isAssistedFinance ? '.assisted' : ''}`)}
            {status === STATUSES.REJECTED && t(`orderReview.checkoutFinance.left.title.failed${isAssistedFinance ? '.assisted' : ''}`)}
            {status === STATUSES.PENDING && IS_B2B && (
                <div className="b2b">{t(`orderReview.checkoutFinance.left.title.pending.b2b${isAssistedFinance ? '.assisted' : ''}`)}</div>
            )}
            {status === STATUSES.PENDING && !IS_B2B && t(`orderReview.checkoutFinance.left.title.pending${isAssistedFinance ? '.assisted' : ''}`)}
            {isRentJourney && t('checkout.orderReview.title.rent')}
        </div>
    );
};

export default CheckoutTitleTemplate;
